
































































import { Vue, Prop, Component } from 'vue-property-decorator';
import { cardMessage } from '../interface';
import { WrappedFormUtils } from 'ant-design-vue/types/form/form';
import { profile } from '@/Utils/profile';
const ieslabDisableRules = profile.get('ieslabDisableRules') === 'true';

/**
 * @author guan
 * @description 卡片重写
 */
@Component({
    components: {},
    data() {
        return {
            form: this.$form.createForm(this, { name: 'ParamCard' }),
        };
    },
})
export default class ParamCard extends Vue {
    /** disabledFunction */
    disabledFunction = ieslabDisableRules;
    /** 切换输入显示 */
    inputVisible = false;
    /** */
    form!: WrappedFormUtils;

    /** 渲染参数 */
    @Prop({
        default: () => {
            return { color: '#fff', content: '', value: 0, icon: '' };
        },
    })
    cardMessage!: cardMessage;

    /**
     * 编辑
     */
    onClickEditButton(): void {
        this.inputVisible = !this.inputVisible;
    }
    /**
     * 确定修改
     */
    confirm(): void {
        this.form.validateFields((errors) => {
            if (errors == null) {
                const value = this.form.getFieldValue(`${this.cardMessage.content}`);
                this.$emit('updateData', { content: this.cardMessage.content, data: value });
                this.inputVisible = !this.inputVisible;
            }
        });
    }

    /**
     * 取消编辑
     */
    cancel(): void {
        this.inputVisible = !this.inputVisible;
    }

    /**
     * checkInput
     */
    checkInput(_rule: any, value: string, callback: Function): void {
        //eslint-disable-line
        if (!this.cardMessage.rate) {
            if (value.length > 0) {
                if (isNaN(Number(value))) {
                    callback(new Error('该字段只能为数字'));
                }
                if (Number(value) < 0) {
                    callback(new Error('该字段不能为负数'));
                } else {
                    callback();
                    return;
                }
            } else {
                callback(new Error('该字段不能为空'));
            }
        } else {
            if (value.length > 0) {
                if (isNaN(Number(value))) {
                    callback(new Error('该字段只能为数字'));
                }
                if (Number(value) < 0) {
                    callback(new Error('该字段不能为负数'));
                }
                if (Number(value) > 100) {
                    callback(new Error('该字段不能大于100'));
                } else {
                    callback();
                    return;
                }
            } else {
                callback(new Error('该字段不能为空'));
            }
        }
    }

    /**
     * mounted
     */
    mounted(): void {
        this.disabledFunction = ieslabDisableRules;
    }
}
